// /app/frontend/src/components/frugal-v2/components/ScanReceiptCard.jsx
// Standalone Scan Receipt card - last card in dashboard

import React, { useState } from 'react';
import { Camera } from 'lucide-react';
import ReceiptScanner from './ReceiptScanner';
import AccountSelector from './AccountSelector';

const ScanReceiptCard = ({ token, t, onAdd }) => {
  const [showScanner, setShowScanner] = useState(false);
  const [pendingExpense, setPendingExpense] = useState(null);

  const handleResult = (data) => {
    setPendingExpense({
      name: data.name,
      amount: data.amount,
      category: data.category || 'Otros',
      date: data.date
    });
  };

  const handleAccountSelect = async (account) => {
    if (!pendingExpense || !onAdd) {
      setPendingExpense(null);
      return;
    }
    try {
      const today = new Date().getDate();
      await onAdd({
        name: pendingExpense.name,
        description: pendingExpense.name,
        amount: pendingExpense.amount,
        category: pendingExpense.category || 'Otros',
        day: today,
        paid_with_account: account.id
      });
    } catch (err) {
      console.error('[ScanReceiptCard] Error:', err);
    } finally {
      setPendingExpense(null);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowScanner(true)}
        data-testid="scan-receipt-card"
        className="w-full rounded-xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/15 to-emerald-600/5 hover:from-emerald-500/25 hover:to-emerald-600/10 transition-all p-4 flex items-center justify-center gap-3 group"
      >
        <div className="w-10 h-10 rounded-lg bg-emerald-500/20 flex items-center justify-center group-hover:bg-emerald-500/30 transition-colors">
          <Camera className="w-5 h-5 text-emerald-400" />
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold text-emerald-400">
            {t ? t('frugal.transactions.scanReceipt', 'Escanear Recibo') : 'Escanear Recibo'}
          </div>
          <div className="text-xs text-slate-400">
            {t ? t('frugal.transactions.scanReceiptDesc', 'Toma foto del recibo para registrar gasto') : 'Toma foto del recibo'}
          </div>
        </div>
      </button>

      <ReceiptScanner
        isOpen={showScanner}
        onClose={() => setShowScanner(false)}
        onResult={handleResult}
        token={token}
        t={t}
      />

      <AccountSelector
        isOpen={!!pendingExpense}
        onClose={() => setPendingExpense(null)}
        onSelect={handleAccountSelect}
        amount={pendingExpense?.amount}
        description={pendingExpense?.name}
        token={token}
        t={t}
      />
    </>
  );
};

export default ScanReceiptCard;
